import BaseService from '../baseServices';
import REST from '../../configs/rest';

function postHoliday({ body }) {
  return BaseService.post(REST.HOLIDAYS, body);
}

function putHoliday({ body, id }) {
  return BaseService.put(REST.HOLIDAYS_ID(id), body);
}

function getHolidays(params) {
  return BaseService.get(REST.HOLIDAYS, {
    params,
  });
}

function deleteHoliday({ id }) {
  return BaseService.delete(REST.HOLIDAYS_ID(id));
}

export default {
  getHolidays,
  postHoliday,
  putHoliday,
  deleteHoliday,
};
